import styles from "./CppPopUp.scss";
import { getLocalizedStrings } from "./popupLocalizedStrings";


function CppPopup(props) {

    let cppStrings = getLocalizedStrings("CppAlerts");
    let language= drupalSettings.custom.currentLanguage.current_language;
    let learnMoreLink= "/"+language+"/business/rates/cpp";
    
    return (
        <div>
            <div className={styles.popUp}>
                <div className={styles.popupContent}>
                    {props.infoPopupTxt}
                </div>


            </div>
        </div>

    );
}

export default CppPopup;